<script lang="ts">
import { defineComponent } from "vue";
import { injectProbe } from "@/shared/utils/injection";
import KlereoBanner from "@/shared/components/KlereoBanner.vue";

export default defineComponent({
  ...injectProbe,
  components: {
    KlereoBanner,
  },
  props: {
    label: String,
    withChart: {
      type: Boolean,
      default: true,
    },
    ioType: {
      required: false,
      type: Number,
    },
    ioIndex: {
      required: false,
      type: Number,
    },
  },
});
</script>

<template>
  <div class="probe-view">
    <klereo-banner
      left-icon="arrow-left"
      :left-link="`/pool/${$route.params.poolId}`"
      :right-icon="withChart ? 'chart' : undefined"
      :right-link="`/pool/${$route.params.poolId}/probe/${$route.params.probeIdx}/history`"
      :title="label"
      :description="pool.poolNickname"
      :io-type="ioType"
      :io-index="ioIndex"
    >
      <button
        class="btn--primary py-0.5 px-2 rounded-xl bigger-clickable-area"
        v-if="isPoolDirty"
        @click="
          savePool().then(() =>
            $router.replace(`/pool/${$route.params.poolId}`)
          )
        "
      >
        {{ $t("Save") }}
      </button>
    </klereo-banner>
  </div>
</template>
